import { useState, useEffect } from "react";
import Layout from "../Component/Layout";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import PropTypes from "prop-types";
import { ORDER_API } from "../apiConfig";
import {
  BarChart, Bar,
  LineChart, Line,
  PieChart, Pie,
  AreaChart, Area,
  XAxis, YAxis, Tooltip,
  CartesianGrid, ResponsiveContainer, Cell
} from "recharts";
 


const EnquiryDashboard = () => {


  const navigate = useNavigate();


  // ================= STATE =================
  const [filters, setFilters] = useState({
    year: "",
    month: "",
    from: "",
    to: "",
    customer: "",
    enquiry_type: "",
    sales_organisation: "",
    customer_segment: "",
    distribution_channel: "",
     product_code: ""
  });


  const [filterOptions, setFilterOptions] = useState({
    customer: [],
    enquiry_type: [],
    sales_organisation: [],
    customer_segment: [],
    distribution_channel: [],
    product_code: [],
    status: []
  });
  const [years, setYears] = useState([]);


  const [counts, setCounts] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const [amounts, setAmounts] = useState({});
  const [totalEnquiry, setTotalEnquiry] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [tableData, setTableData] = useState([]);


  const [view, setView] = useState("table");
  const [chartType, setChartType] = useState("bar");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;


const customSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 32,
    height: 32,
    fontSize: "12.5px",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "32px",
    padding: "0 6px"
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 3
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: "13px",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "180px"
  }),
  option: (base) => ({
    ...base,
    whiteSpace: "normal",
    wordBreak: "break-word"
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 3,
    cursor: "pointer"
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "32px"
  }),
  singleValue: (base) => ({
    ...base,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
};

//   const FONT = {
//   fontFamily: '"Inter", "Segoe UI", sans-serif',
// };

const headingStyle = {
  margin: "0 0 8px 0",
  color: "#0f172a",
  fontWeight: "700",
  fontSize: "32px"
};

const labelStyle = {
  fontSize: "12px",
  fontWeight: 500,
  color: "#374151",
};

const inputStyle = {
  fontSize: "14px",
};

const tableHeaderStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color:"#000",
};

const tableCellStyle = {
  fontSize: "14px",
  color:"#000",
};


  // ================= FUNCTIONS =================
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };


  const formatCurrency = (value) => {
  const num = Number(value || 0);

  // Truncate (not round) to 2 decimals
  const truncate2 = (n, divisor) =>
    (Math.floor((n * 100) / divisor) / 100).toFixed(2);

  if (num >= 10000000) return `₹ ${truncate2(num, 10000000)} Cr`;
  if (num >= 100000)   return `₹ ${truncate2(num, 100000)} Lakh`;

  return `₹ ${num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};


  const showToast = (msg, type = "error") => {
    const toast = document.createElement("div");
    toast.innerText = msg;


    toast.style.position = "fixed";
    toast.style.top = "20px";
    toast.style.right = "20px";
    toast.style.background = type === "success" ? "#16a34a" : "#ef4444"; // ✅ green/red
    toast.style.color = "#fff";
    toast.style.padding = "10px 16px";
    toast.style.borderRadius = "8px";
    toast.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
    toast.style.zIndex = "9999";


    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  };




  const handleExport = async () => {
    let query = new URLSearchParams(filters).toString();


    // ✅ include status
    if (selectedStatus.length) {
      const statusValues = selectedStatus.map(s => s.value).join(",");
      query += `&status=${statusValues}`;
    }


    try {
      const res = await fetch(
        `${ORDER_API}/enquirydashboard/export?${query}`
      );


      // ✅ if no data
      if (res.headers.get("content-type")?.includes("application/json")) {
        const data = await res.json();


        if (!data.success) {
          showToast(data.message || "No data to export");
          return;
        }
      }


      // ✅ download file
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);


      const a = document.createElement("a");
      a.href = url;
      a.download = "enquiry.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      showToast("Export successful", "success");


    } catch (err) {
      console.error(err);
      showToast("Export failed");
    }
  };


  // ✅ ADD HERE
  const handleReset = () => {
    setFilters({
  year: "",
  month: "",
  from: "",
  to: "",
  customer: "",
  enquiry_type: "",
  sales_organisation: "",
  customer_segment: "",
  distribution_channel: "",
  product_code: ""
});


    setSelectedStatus([]);
  };
  // ================= FETCH FILTERS =================
  useEffect(() => {
    fetch(`${ORDER_API}/enquirydashboard/filters`)
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          setFilterOptions(res.data);
          setYears(res.data.year || []);
        }
      });
  }, []);


  // ================= TOTAL =================
  useEffect(() => {
    fetch(`${ORDER_API}/enquirydashboard/total`)
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          setTotalEnquiry(res.data.totalEnquiry || 0);
          setTotalValue(res.data.totalValue || 0);
        }
      });
  }, []);




  useEffect(() => {
    fetch(`${ORDER_API}/enquirydashboard/status-options`)
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          setStatusOptions(res.data);
        }
      });
  }, []);
  // ================= FETCH DATA =================
  useEffect(() => {
    const fetchData = async () => {
      const query = new URLSearchParams(filters).toString();


      const statusQuery =
        selectedStatus.length > 0
          ? `&status=${selectedStatus.map(s => s.value).join(",")}`
          : "";


      try {
        const [countsRes, amountsRes, tableRes] = await Promise.all([
          fetch(`${ORDER_API}/enquirydashboard/counts?${query}`),
          fetch(`${ORDER_API}/enquirydashboard/amounts?${query}`),
          fetch(`${ORDER_API}/enquirydashboard/table?${query}${statusQuery}`)
        ]);


        const countsData = await countsRes.json();
        const amountsData = await amountsRes.json();
        const tableDataRes = await tableRes.json();


        if (countsData.success) {
          setCounts(countsData.data);
          setTotalEnquiry(countsData.data.totalEnquiry || 0); // ✅ IMPORTANT FIX
        }


        if (amountsData.success) {
          setAmounts(amountsData.data);
        }


        if (tableDataRes.success) {
          setTableData(tableDataRes.data);
        }


      } catch (err) {
        console.error("API Error:", err);
      }
    };


    fetchData();
  }, [filters, selectedStatus]);


  useEffect(() => {
    setCurrentPage(1);
  }, [filters, selectedStatus]);


  const filteredTableData = tableData;


  // ✅ PAGINATION
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;


  const currentTableData = filteredTableData.slice(indexOfFirstRow, indexOfLastRow);


  const totalPages = Math.ceil(filteredTableData.length / rowsPerPage);


  // ================= GRAPH DATA =================
  const graphData = [
    {
      name: "Total Enquiry",
      count: totalEnquiry || 0,
      amount: Number(amounts?.totalValue ?? totalValue ?? 0)
    },


    {
      name: "Enquiry → RFQ",
      count: counts.enquiryToRFQ || 0,
      amount: Number(amounts?.enquiryToRFQValue ?? 0)
    }
  ];


  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;


      CustomTooltip.propTypes = {
        active: PropTypes.bool,
        payload: PropTypes.array,
        label: PropTypes.string
      };


      return (
        <div style={{
          background: "#fff",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
        }}>
          <b>{data.name}</b>
          <div>Count: {data.count}</div>
          <div style={{ color: "#16a34a" }}>
            ₹ {(data.amount / 10000000).toFixed(2)} Cr
          </div>
        </div>
      );
    }
    return null;
  };




  return (
    <Layout defaultSidebarOpen={false}>
      <div className="container-fluid p-4">


        {/* ================= HEADER + DATE FILTERS ================= */}
<div
  className="d-flex justify-content-between align-items-end flex-wrap gap-3"
  style={{ marginBottom: "24px" }}
>
  <div>
    <h2 style={headingStyle}>Enquiry Dashboard</h2>
    <p style={{ fontSize: "13px", color: "#6b7280", margin: 0 }}>
      Manage your enquiry dashboard.
    </p>
  </div>

  <div className="d-flex align-items-end gap-2 flex-wrap">
    <div>
      <label className="form-label" style={labelStyle}>Year</label>
      <select
        name="year"
        value={filters.year}
        className="form-select form-select-sm"
        style={{ ...inputStyle, width: "90px" }}
        onChange={handleChange}
      >
        <option value="">All</option>
        {years.map((y, i) => (
          <option key={i} value={y}>{y}</option>
        ))}
      </select>
    </div>

    <div>
      <label className="form-label" style={labelStyle}>Month</label>
      <select
        name="month"
        value={filters.month}
        className="form-select form-select-sm"
        style={{ ...inputStyle, width: "110px" }}
        onChange={handleChange}
      >
        <option value="">All</option>
        <option value="01">January</option>
        <option value="02">February</option>
        <option value="03">March</option>
        <option value="04">April</option>
        <option value="05">May</option>
        <option value="06">June</option>
        <option value="07">July</option>
        <option value="08">August</option>
        <option value="09">September</option>
        <option value="10">October</option>
        <option value="11">November</option>
        <option value="12">December</option>
      </select>
    </div>

    <div>
      <label className="form-label" style={labelStyle}>From</label>
      <input
        type="date"
        name="from"
        value={filters.from}
        className="form-control form-control-sm"
        style={{ ...inputStyle, width: "135px" }}
        onChange={handleChange}
      />
    </div>

    <div>
      <label className="form-label" style={labelStyle}>To</label>
      <input
        type="date"
        name="to"
        value={filters.to}
        className="form-control form-control-sm"
        style={{ ...inputStyle, width: "135px" }}
        onChange={handleChange}
      />
    </div>

    <button
      className="btn btn-sm"
      style={{
        background: "#0047AB",
        color: "#fff",
        border: "1px solid #0047AB",
        fontWeight: 500
      }}
      onClick={handleReset}
    >
      Reset
    </button>
  </div>
</div>


       {/* ================= ADV FILTER ================= */}
<div className="d-flex flex-wrap gap-2 mt-2">
  {[
    { key: "product_code", label: "Product Code", width: 170 },
    { key: "customer", label: "Customer", width: 170 },
    { key: "enquiry_type", label: "Types Of Enquiry", width: 150 },
    { key: "sales_organisation", label: "Sales Organisation", width: 150 },
    { key: "customer_segment", label: "Customer Segment", width: 150 },
    { key: "distribution_channel", label: "Distribution Channel", width: 160 }
  ].map((f, i) => {
    // Build a consistent {label, value} option list regardless of
    // whether the API gave us plain strings (customer, enquiry_type, etc.)
    // or {value, label} objects (product_code, which needs the description).
    const options =
      f.key === "product_code"
        ? filterOptions[f.key] || []
        : (filterOptions[f.key] || []).map(v => ({ label: v, value: v }));

    // Look up the REAL option (with full label) that matches the current
    // filter value, instead of rebuilding a fake one from the raw code.
    const selectedOption =
      options.find(o => o.value === filters[f.key]) || null;

    return (
      <div key={i} style={{ width: f.width }} title={selectedOption?.label || ""}>
        <label className="form-label" style={labelStyle}>
          {f.label}
        </label>

        <Select
          styles={customSelectStyles}
          value={selectedOption}
          options={options}
          onChange={(s) =>
            setFilters({
              ...filters,
              [f.key]: s ? s.value : ""
            })
          }
          isClearable
        />
      </div>
    );
  })}
</div>

        {/* ================= TILES ================= */}
<div className="d-flex flex-wrap gap-3 mt-3">
  {[
    { title: "Total Enquiry", value: totalEnquiry, amount: totalValue, class: "tile-blue" },
    { title: "Enquiry → RFQ", value: counts.enquiryToRFQ, amount: amounts.enquiryToRFQValue, class: "tile-orange" },
  ].map((t, i) => {

    const borderColor =
      t.class === "tile-blue" ? "#3b82f6" :
        t.class === "tile-green" ? "#16a34a" :
          t.class === "tile-purple" ? "#9333ea" :
            t.class === "tile-orange" ? "#f59e0b" :
              t.class === "tile-red" ? "#ef4444" :
                "#6b7280";

    return (
      <div
        key={i}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 10px 18px rgba(0,0,0,0.12)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.06)";
        }}
        onClick={() => {
          const title = t.title;

          if (title === "Total Enquiry") {
            setSelectedStatus([]);
            return;
          }

          if (title === "Enquiry → RFQ") {
            setSelectedStatus([
              { label: "Enquiry → RFQ", value: "RFQ" }
            ]);
          }
        }}
        style={{
          width: "230px",
          background: "#f3f4f6",
          borderRadius: "12px",
          padding: "12px 14px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          cursor: "pointer",
          borderLeft: `5px solid ${borderColor}`,
          transition: "all 0.2s ease"
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 600, color: "#374151" }}>
          {t.title}
        </div>

        <div style={{ fontSize: "20px", fontWeight: 700, color: "#000", marginTop: "4px" }}>
          {t.value || 0}
        </div>

        <div style={{ fontSize: "14px", fontWeight: 600, color: "#000", marginTop: "4px", alignSelf: "flex-end" }}>
          {formatCurrency(t.amount)}
        </div>
      </div>
    );
  })}
</div>

        {/* ================= TOGGLE + STATUS + EXPORT ================= */}
        <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">


          {/* LEFT */}
          <div className="btn-group btn-group-sm">
            <button
              className="btn"
              style={{
                background: view === "table" ? "#0047AB" : "transparent",
                color: view === "table" ? "#fff" : "#0047AB",
                fontWeight: 500,
                border: "1px solid #0047AB"
              }}
              onClick={() => setView("table")}
            >
              Table
            </button>


            <button
              className="btn"
              style={{
                background: view === "graph" ? "#0047AB" : "transparent",
                color: view === "graph" ? "#fff" : "#0047AB",
                border: "1px solid #0047AB"
              }}
              onClick={() => setView("graph")}
            >
              Graph
            </button>
          </div>


          {/* RIGHT */}
          <div className="d-flex align-items-center gap-2">

            <div style={{ width: "160px" }} title={selectedStatus.length ? selectedStatus[0].label : ""}>
              <Select
                styles={customSelectStyles}
                isClearable
                options={statusOptions}
                value={
                  selectedStatus.length
                    ? selectedStatus[0]
                    : null
                }
                onChange={(s) => {
                  if (!s) {
                    setSelectedStatus([]);
                    return;
                  }

                  if (s.value === "ALL") {
                    setSelectedStatus([]);
                  }

                  if (s.value === "RFQ") {
                    setSelectedStatus([{ label: "Enquiry → RFQ", value: "RFQ" }]);
                  }
                }}
                placeholder="Select Status"
              />
            </div>

            <button
              className="btn btn-sm"
              style={{
                background: "#0047AB",
                color: "#fff",
                border: "1px solid #0047AB",
                fontWeight: 500
              }}
              onClick={handleExport}
            >
              Export
            </button>

          </div>
        </div>


        {/* ================= GRAPH ================= */}
        {view === "graph" && amounts && (
          <div
            style={{
              background: "#f8fafc",
              borderRadius: "16px",
              padding: "20px",
            }}
          >
            {/* Title */}
            <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>
              Enquiry Status Overview
            </h5>


            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <select
                value={chartType}
                onChange={(e) => setChartType(e.target.value)}
                style={{ padding: "6px", marginBottom: "10px" }}
              >
                <option value="bar">Bar Chart</option>
                <option value="line">Line Chart</option>
                <option value="pie">Pie Chart</option>
                <option value="area">Area Chart</option>
              </select>
            </div>


            <ResponsiveContainer width="100%" height={320}>


              {/* BAR */}
              {chartType === "bar" && (
                <BarChart data={graphData} barCategoryGap="40%">
                  <CartesianGrid
                    strokeDasharray="3 3"
                    vertical={false}
                    stroke="#e5e7eb"
                  />


                  <XAxis
                    dataKey="name"
                    tick={{ fontSize: 13, fill: "#6b7280" }}
                    axisLine={false}
                    tickLine={false}
                  />


                  <YAxis
                    tick={{ fontSize: 12, fill: "#6b7280" }}
                    axisLine={false}
                    tickLine={false}
                  />


                  <Tooltip content={<CustomTooltip />} />


                  <Bar dataKey="count" radius={[10, 10, 0, 0]} barSize={40}>
                    {graphData.map((entry, index) => {
                      const colors = [
                        "#3b82f6", // Total Enquiry (Blue)
                        "#f59e0b"  // Enquiry → RFQ (Orange)
                      ];
                      return <Cell key={index} fill={colors[index]} />;
                    })}
                  </Bar>
                </BarChart>
              )}


              {/* LINE */}
              {chartType === "line" && (
                <LineChart data={graphData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip content={<CustomTooltip />} />
                  <Line type="monotone" dataKey="count" stroke="#3b82f6" />
                </LineChart>
              )}


              {/* AREA */}
              {chartType === "area" && (
                <AreaChart data={graphData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip content={<CustomTooltip />} />
                  <Area type="monotone" dataKey="count" stroke="#3b82f6" fill="#93c5fd" />
                </AreaChart>
              )}


              {/* PIE */}
              {chartType === "pie" && (
                <PieChart>
                  <Pie
                    data={graphData}
                    dataKey="count"
                    nameKey="name"
                    outerRadius={100}
                  >
                    {graphData.map((entry, index) => {
                      const colors = [
                        "#3b82f6", // Total Enquiry (Blue)
                        "#f59e0b"  // Enquiry → RFQ (Orange)
                      ];
                      return <Cell key={index} fill={colors[index]} />;
                    })}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                </PieChart>
              )}


            </ResponsiveContainer>
          </div>
        )}
        {/* ================= TABLE ================= */}
        {view === "table" && (
          <div
            className="mt-3"
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              width: "100%"
            }}
          >


            <div className="table-responsive">
              <table
                className="table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse"
                }}
              >


                {/* Header */}
                <thead>
                  <tr>
                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Enquiry ID
                    </th>


                    {/* <th style={{
                      background: "#f5f6fa",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}>
                      Product Code
                    </th> */}


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Type Of Enquiry
                    </th>


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Sales Organisation
                    </th >


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Customer Segment
                    </th>


                    {/* <th style={{
                      background: "#f5f6fa",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd"
                    }}>
                      Division
                    </th> */}


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Distribution Channel
                    </th>


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Customer
                    </th>


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Status
                    </th>


                    <th
  style={{
    ...tableHeaderStyle,
    background: "#f5f6fa",
    padding: "10px",
    borderBottom: "1px solid #ddd"
  }}
>
                      Total Value
                    </th>
                  </tr>
                </thead>


                {/* Body */}
                <tbody>
                  {filteredTableData.length ? (
                    currentTableData.map((r, i) => (
                      <tr key={i}>


                        {/* Enquiry ID */}
                        <td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
                          <span
                            onClick={() =>
                              navigate("/cable/sales/enquiry", {
                                state: {
                                  inquiryId: r.enquiry_id,
                                  from: "dashboard"
                                }
                              })
                            }
                            style={{
                              cursor: "pointer",
                              color: "#2563eb",
                              fontWeight: "500"
                            }}
                          >
                            {r.enquiry_id}
                          </span>
                        </td>


                        {/* Product Code */}
                        {/* <td style={{
                          fontSize: "14px",
                          padding: "10px",
                          borderBottom: "1px solid #eee"
                        }}>
                          {r.product_code?.split(",").map((p, i) => (
                            <div key={i}>{p.trim()}</div>
                          ))}
                        </td> */}


                        {/* Division */}
                        {/* <td style={{
                          fontSize: "14px",
                          padding: "10px",
                          borderBottom: "1px solid #eee"
                        }}>
                          {r.division}
                        </td> */}


                        {/* Type Of Enquiry */}
<td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
  {r.enquiry_type}
</td>


{/* Sales Organisation */}
<td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
  {r.sales_organisation}
</td>


{/* Customer Segment */}
<td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
  {r.customer_segment}
</td>


{/* Distribution */}
<td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
  {r.distribution_channel}
</td>


                        {/* Customer */}
                        <td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
                          {r.customer}
                        </td>


                        {/* Status */}
                        <td
  style={{
    ...tableCellStyle,
    padding: "10px",
    borderBottom: "1px solid #eee"
  }}
>
                          {r.enquiry_status}
                        </td>


                        {/* Total Value */}
                        <td
                          title={`₹ ${Number(r.total_value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                          style={{ ...tableCellStyle, padding: "10px", borderBottom: "1px solid #eee", textAlign: "right", whiteSpace: "nowrap", fontWeight: 500 }}
                        >
                          {formatCurrency(r.total_value)}
                        </td>


                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{
                        textAlign: "center",
                        padding: "12px"
                      }}>
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>


              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">


              <div style={{ fontSize: "14px" }}>
                Page {currentPage} of {totalPages || 1}
              </div>


              <div>
                <button
                  className="btn btn-sm btn-outline-secondary me-2"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Prev
                </button>


                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>


            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};


export default EnquiryDashboard;
